var r=function(r){void 0===r&&(r=6);for(var a="",o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",t=0;r>t;)a+=o.charAt(Math.floor(62*Math.random())),t+=1;return a};export{r as g};
//# sourceMappingURL=getRandomString.js.map
